export const JUNIOR = 'junior';
export const MIDDLE = 'middle';
export const SENIOR = 'senior';
